export default __webpack_public_path__ + "images/MN.68e5909.png";